import { AddonDiscoveryTelemetry } from '@atlassian/amkt-addon-discovery';
import { AppListingTelemetry } from '@atlassian/mpac-app-listing';
import Telemetry from '@atlassian/mpac-telemetry';

// #region Home Page Tasks
export const HomePageTask = Telemetry.createPageViewTask('view-home-page').dependsOn([
  AddonDiscoveryTelemetry.DiscoveryFacetsTask,
  AddonDiscoveryTelemetry.DiscoveryCollectionsTask,
]);
// #endregion

// #region Search Page Tasks
export const SearchPageTask = Telemetry.createPageViewTask('view-search-results-page').dependsOn([
  AddonDiscoveryTelemetry.SearchTask,
]);
// #endregion

// #region App Listing Page Tasks
export const AppListingPageTask = Telemetry.createPageViewTask('view-app-listing-page').dependsOn([
  AppListingTelemetry.AppListingTask,
]);
// #endregion

// #region Collection Page Tasks
export const CollectionPageTask = Telemetry.createPageViewTask('view-collection-page');
export const CollectionPageLoadMore = Telemetry.createGenericTask('collection-page-load-more');
export const CollectionPageFilterApply = Telemetry.createGenericTask(
  'collection-page-filter-apply'
);
// #endregion

// #region Category Page Tasks
export const CategoryPageTask = Telemetry.createPageViewTask('view-category-page');
export const CategoryPageLoadMore = Telemetry.createGenericTask('category-page-load-more');
export const CategoryPageFilterApply = Telemetry.createGenericTask('category-page-filter-apply');
// #endregion

// #region Partner Profile Page Tasks
export const PartnerProfilePageTask = Telemetry.createPageViewTask('view-partner-profile-page');
export const PartnerProfilePageLoadMore = Telemetry.createGenericTask(
  'partner-profile-page-load-more'
);
// #endregion
